// // import { useEffect, useState } from "react";
// // import { useNavigate } from "react-router-dom";
// // import api from "../api/axiosInstance";

// // const Restaurant = () => {
// //   const navigate = useNavigate();
// //   const [categories, setCategories] = useState([]);
// //   const [loading, setLoading] = useState(true);
// //   const [currentSlide, setCurrentSlide] = useState(0);
// //   const [selectedImage, setSelectedImage] = useState(null);

// //   const carouselImages = [
// //     {
// //       id: 1,
// //       image:
// //         "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758112819/WhatsApp_Image_2025-09-17_at_5.57.59_PM-min_trljoi.jpg",
// //     },
// //     {
// //       id: 2,
// //       image:
// //         "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758112819/WhatsApp_Image_2025-09-17_at_5.57.46_PM-min_sjhcpy.jpg",
// //     },
// //     {
// //       id: 3,
// //       image:
// //         "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758112819/WhatsApp_Image_2025-09-17_at_5.58.00_PM-min_geltlb.jpg",
// //     },
// //   ];

// //   // 🔹 Fetch categories from backend
// //   useEffect(() => {
// //     const fetchCategories = async () => {
// //       try {
// //         const res = await api.get("/restaurant/categories/get/all");
// //         setCategories(res.data);
// //       } catch (err) {
// //         console.error("Failed to load categories:", err);
// //       } finally {
// //         setLoading(false);
// //       }
// //     };
// //     fetchCategories();
// //   }, []);

// //   // 🔹 Carousel autoplay
// //   useEffect(() => {
// //     const interval = setInterval(() => {
// //       setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
// //     }, 5000);
// //     return () => clearInterval(interval);
// //   }, [carouselImages.length]);

// //   if (loading)
// //     return <p className="text-center text-gray-600 mt-10">Loading menu...</p>;

// //   return (
// //     <div className="bg-[#fffdf6] min-h-screen py-12 px-4 md:px-10 lg:px-20 relative">
// //       <div className="max-w-7xl mx-auto">
// //         <h1 className="text-3xl md:text-4xl font-bold text-center mb-12 uppercase">
// //           Golf View Cafe
// //         </h1>

// //         <div className="flex flex-col md:flex-row gap-6 md:gap-8">
// //           {/* Categories List */}
// //           <div className="md:w-2/5 flex flex-col">
// //             <h2 className="text-xl sm:text-3xl font-semibold text-center mb-4">
// //               Menu
// //             </h2>

// //             <div className="space-y-4 md:space-y-6 overflow-y-auto max-h-80 pr-2">
// //               {categories.map((cat) => (
// //                 <div
// //                   key={cat.id}
// //                   className="bg-white shadow-lg rounded-2xl cursor-pointer hover:shadow-xl transition flex items-center gap-4 p-4 md:p-5 w-full"
// //                   onClick={() => navigate(`/category/${cat.id}`)}
// //                 >
// //                   <img
// //                     src={cat.imageUrl}
// //                     alt={cat.title}
// //                     className="w-16 h-16 sm:w-20 sm:h-20 object-cover rounded-lg"
// //                   />
// //                   <h2 className="text-lg sm:text-xl font-semibold">
// //                     {cat.title}
// //                   </h2>
// //                 </div>
// //               ))}
// //             </div>
// //           </div>

// //           {/* Right Side: Carousel + Info */}
// //           <div className="md:w-3/5 space-y-6">
// //             <div className="bg-white shadow-lg rounded-2xl p-4 relative overflow-hidden">
// //               <div
// //                 className="flex transition-transform duration-1000 ease-in-out"
// //                 style={{ transform: `translateX(-${currentSlide * 100}%)` }}
// //               >
// //                 {carouselImages.map((item) => (
// //                   <div
// //                     key={item.id}
// //                     className="flex-shrink-0 w-full cursor-pointer"
// //                     onClick={() => setSelectedImage(item.image)}
// //                   >
// //                     <img
// //                       src={item.image}
// //                       alt=""
// //                       className="w-full h-56 sm:h-64 md:h-72 lg:h-80 object-cover rounded-lg"
// //                     />
// //                   </div>
// //                 ))}
// //               </div>

// //               <div className="absolute bottom-2 left-1/2 transform -translate-x-1/2 flex gap-2">
// //                 {carouselImages.map((_, idx) => (
// //                   <div
// //                     key={idx}
// //                     className={`w-3 h-3 rounded-full ${
// //                       idx === currentSlide ? "bg-lime-500" : "bg-gray-300"
// //                     }`}
// //                   ></div>
// //                 ))}
// //               </div>
// //             </div>

// //             {/* Pre-book info */}
// //             <div className="bg-gradient-to-r from-indigo-50 via-white to-indigo-50 shadow-2xl rounded-3xl p-6 md:p-8 text-center border border-indigo-100">
// //               <h2 className="text-xl sm:text-2xl font-bold mb-4 text-lime-700">
// //                 ⏰ Opening Hours
// //               </h2>
// //               <ul className="space-y-2 text-gray-700 mb-6">
// //                 <li>
// //                   Saturday - Thursday: 8:00 AM - 12:00 AM and 3:00 PM - 10:00 PM
// //                 </li>
// //                 <li>Friday: 8:00 AM - 10:00 AM and 3:00 PM - 10:00 PM</li>
// //               </ul>
// //               <h3 className="text-xl sm:text-2xl font-bold mb-2 text-lime-600">
// //                 For Pre-Booking
// //               </h3>
// //               <p className="text-base sm:text-lg font-medium text-gray-800">
// //                 Call: +88 01769660123
// //               </p>
// //             </div>
// //           </div>
// //         </div>
// //       </div>

// //       <button
// //         onClick={() => navigate("/review")}
// //         className="fixed top-20 right-1 z-50 px-5 sm:px-6 py-3 rounded-full font-bold text-black bg-gradient-to-r from-lime-500 via-green-400 to-green-500 shadow-xl hover:scale-105 hover:shadow-2xl animate-pulse"
// //       >
// //         ⭐ Rate The Restaurant ⭐
// //       </button>

// //       {/* Image Modal */}
// //       {selectedImage && (
// //         <div
// //           className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
// //           onClick={() => setSelectedImage(null)}
// //         >
// //           <div
// //             className="relative bg-white p-4 rounded-2xl shadow-lg"
// //             onClick={(e) => e.stopPropagation()}
// //           >
// //             <button
// //               className="absolute top-2 right-2 text-gray-700 bg-gray-200 rounded-full px-3 py-1 hover:bg-gray-300"
// //               onClick={() => setSelectedImage(null)}
// //             >
// //               ✕
// //             </button>
// //             <img
// //               src={selectedImage}
// //               alt="Enlarged"
// //               className="max-w-[90vw] max-h-[80vh] rounded-lg"
// //             />
// //           </div>
// //         </div>
// //       )}
// //     </div>
// //   );
// // };

// // export default Restaurant;

// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import api from "../api/axiosInstance";
// import { ChevronLeft, ChevronRight, Clock, Phone, Star } from "lucide-react";

// const Restaurant = () => {
//   const navigate = useNavigate();
//   const [categories, setCategories] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [selectedImage, setSelectedImage] = useState(null);

//   const carouselImages = [
//     {
//       id: 1,
//       image:
//         "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758112819/WhatsApp_Image_2025-09-17_at_5.57.59_PM-min_trljoi.jpg",
//     },
//     {
//       id: 2,
//       image:
//         "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758112819/WhatsApp_Image_2025-09-17_at_5.57.46_PM-min_sjhcpy.jpg",
//     },
//     {
//       id: 3,
//       image:
//         "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758112819/WhatsApp_Image_2025-09-17_at_5.58.00_PM-min_geltlb.jpg",
//     },
//   ];

//   // 🔹 Fetch categories from backend
//   useEffect(() => {
//     const fetchCategories = async () => {
//       try {
//         const res = await api.get("/restaurant/categories/get/all");
//         setCategories(res.data);
//       } catch (err) {
//         console.error("Failed to load categories:", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchCategories();
//   }, []);

//   // 🔹 Carousel autoplay
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
//     }, 5000);
//     return () => clearInterval(interval);
//   }, [carouselImages.length]);

//   const nextSlide = () => {
//     setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
//   };

//   const prevSlide = () => {
//     setCurrentSlide((prev) =>
//       prev === 0 ? carouselImages.length - 1 : prev - 1
//     );
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen bg-gradient-to-br from-green-50 to-lime-50 flex items-center justify-center">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-green-600 mx-auto mb-4"></div>
//           <p className="text-gray-600 text-lg">Loading menu...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-green-50 to-lime-50 py-8 px-4 sm:px-6 lg:px-8 relative">
//       <div className="max-w-7xl mx-auto">
//         {/* Header */}
//         <div className="text-center mb-12">
//           <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-4 tracking-tight">
//             Golf View Cafe
//           </h1>
//           <p className="text-xl md:text-2xl text-gray-600 max-w-2xl mx-auto">
//             Experience exquisite dining with panoramic golf course views
//           </p>
//         </div>

//         <div className="grid grid-cols-1 xl:grid-cols-3 gap-8 lg:gap-12">
//           {/* Categories List - Left Sidebar */}
//           {/* <div className="xl:col-span-1">
//             <div className="bg-white rounded-3xl shadow-2xl p-6 lg:p-8 sticky top-8">
//               <div className="text-center mb-8">
//                 <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-2">
//                   Our Menu
//                 </h2>
//                 <div className="w-24 h-1 bg-gradient-to-r from-green-500 to-lime-500 mx-auto rounded-full"></div>
//               </div>

//               <div className="space-y-4 max-h-[calc(100vh-200px)] overflow-y-auto pr-2 custom-scrollbar">
//                 {categories.map((cat) => (
//                   <div
//                     key={cat.id}
//                     className="group bg-gradient-to-r from-white to-green-50 rounded-2xl cursor-pointer hover:shadow-2xl transition-all duration-300 hover:scale-[1.02] border border-green-100 overflow-hidden"
//                     onClick={() => navigate(`/category/${cat.id}`)}
//                   >
//                     <div className="flex items-center p-4 lg:p-6">
//                       <div className="relative">
//                         <img
//                           src={cat.imageUrl}
//                           alt={cat.title}
//                           className="w-20 h-20 lg:w-24 lg:h-24 object-cover rounded-xl shadow-md group-hover:scale-110 transition-transform duration-300"
//                         />
//                         <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-xl"></div>
//                       </div>
//                       <div className="ml-4 lg:ml-6 flex-1">
//                         <h3 className="text-xl lg:text-2xl font-bold text-gray-900 group-hover:text-green-700 transition-colors">
//                           {cat.title}
//                         </h3>
//                         <div className="w-12 h-1 bg-green-500 mt-2 rounded-full group-hover:w-16 transition-all duration-300"></div>
//                       </div>
//                       <div className="text-green-500 opacity-0 group-hover:opacity-100 transform translate-x-2 group-hover:translate-x-0 transition-all duration-300">
//                         <ChevronRight size={24} />
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div> */}
//           <div className="xl:col-span-1">hello</div>

//           {/* Main Content Area */}
//           <div className="xl:col-span-2 space-y-8 lg:space-y-12">
//             {/* Carousel Section */}
//             <div className="bg-white rounded-3xl shadow-2xl p-4 lg:p-6 relative overflow-hidden">
//               <div className="relative">
//                 <div
//                   className="flex transition-transform duration-700 ease-out"
//                   style={{ transform: `translateX(-${currentSlide * 100}%)` }}
//                 >
//                   {carouselImages.map((item) => (
//                     <div
//                       key={item.id}
//                       className="flex-shrink-0 w-full cursor-pointer"
//                       onClick={() => setSelectedImage(item.image)}
//                     >
//                       <img
//                         src={item.image}
//                         alt="Restaurant ambiance"
//                         className="w-full h-64 sm:h-80 lg:h-96 xl:h-[500px] object-cover rounded-2xl shadow-lg"
//                       />
//                     </div>
//                   ))}
//                 </div>

//                 {/* Navigation Arrows */}
//                 <button
//                   onClick={prevSlide}
//                   className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-gray-800 rounded-full p-3 shadow-2xl transition-all duration-200 hover:scale-110"
//                 >
//                   <ChevronLeft size={24} />
//                 </button>
//                 <button
//                   onClick={nextSlide}
//                   className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-gray-800 rounded-full p-3 shadow-2xl transition-all duration-200 hover:scale-110"
//                 >
//                   <ChevronRight size={24} />
//                 </button>

//                 {/* Dots Indicator */}
//                 <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-3">
//                   {carouselImages.map((_, idx) => (
//                     <button
//                       key={idx}
//                       onClick={() => setCurrentSlide(idx)}
//                       className={`w-3 h-3 rounded-full transition-all duration-300 ${
//                         idx === currentSlide
//                           ? "bg-white scale-125"
//                           : "bg-white/60 hover:bg-white/80"
//                       }`}
//                     ></button>
//                   ))}
//                 </div>
//               </div>
//             </div>

//             {/* Info Cards Grid */}
//             <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
//               {/* Opening Hours */}
//               <div className="bg-gradient-to-br from-green-500 to-lime-600 rounded-3xl p-6 lg:p-8 text-white shadow-2xl">
//                 <div className="flex items-center mb-6">
//                   <div className="bg-white/20 p-3 rounded-2xl mr-4">
//                     <Clock size={32} />
//                   </div>
//                   <h2 className="text-2xl lg:text-3xl font-bold">
//                     Opening Hours
//                   </h2>
//                 </div>

//                 <div className="space-y-4 text-lg">
//                   <div className="flex justify-between items-center py-3 border-b border-white/20">
//                     <span className="font-semibold">Saturday - Thursday</span>
//                     <div className="text-right">
//                       <div>8:00 AM - 12:00 AM</div>
//                       <div>3:00 PM - 10:00 PM</div>
//                     </div>
//                   </div>
//                   <div className="flex justify-between items-center py-3">
//                     <span className="font-semibold">Friday</span>
//                     <div className="text-right">
//                       <div>8:00 AM - 10:00 AM</div>
//                       <div>3:00 PM - 10:00 PM</div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Pre-booking Info */}
//               <div className="bg-gradient-to-br from-indigo-500 to-purple-600 rounded-3xl p-6 lg:p-8 text-white shadow-2xl">
//                 <div className="flex items-center mb-6">
//                   <div className="bg-white/20 p-3 rounded-2xl mr-4">
//                     <Phone size={32} />
//                   </div>
//                   <h2 className="text-2xl lg:text-3xl font-bold">
//                     Pre-Booking
//                   </h2>
//                 </div>

//                 <div className="space-y-6">
//                   <p className="text-xl leading-relaxed">
//                     Reserve your table in advance for the perfect dining
//                     experience
//                   </p>

//                   <div className="bg-white/10 rounded-2xl p-4 text-center">
//                     <div className="text-2xl lg:text-3xl font-bold mb-2">
//                       +88 01769660123
//                     </div>
//                     <p className="text-white/80">Call now to book your table</p>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Additional Info */}
//             <div className="bg-white rounded-3xl shadow-2xl p-6 lg:p-8">
//               <h3 className="text-2xl lg:text-3xl font-bold text-center mb-6 text-gray-900">
//                 Why Choose Golf View Cafe?
//               </h3>
//               <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
//                 <div className="space-y-3">
//                   <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mx-auto">
//                     <span className="text-2xl">🌿</span>
//                   </div>
//                   <h4 className="font-bold text-lg text-gray-900">
//                     Fresh Ingredients
//                   </h4>
//                   <p className="text-gray-600">
//                     Locally sourced, premium quality ingredients
//                   </p>
//                 </div>
//                 <div className="space-y-3">
//                   <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mx-auto">
//                     <span className="text-2xl">🏌️</span>
//                   </div>
//                   <h4 className="font-bold text-lg text-gray-900">
//                     Golf Course Views
//                   </h4>
//                   <p className="text-gray-600">
//                     Panoramic views of the beautiful golf course
//                   </p>
//                 </div>
//                 <div className="space-y-3">
//                   <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mx-auto">
//                     <span className="text-2xl">👨‍🍳</span>
//                   </div>
//                   <h4 className="font-bold text-lg text-gray-900">
//                     Expert Chefs
//                   </h4>
//                   <p className="text-gray-600">
//                     Skilled chefs creating culinary masterpieces
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Floating Review Button */}
//       <button
//         onClick={() => navigate("/review")}
//         className="fixed top-20 right-1 z-40 lg:z-50 mt-[15px] px-6 py-2 lg:py-4 text-[14px] lg:text-[18px] rounded-2xl font-bold text-white bg-gradient-to-r from-lime-500 to-lime-500 shadow-2xl hover:shadow-3xl hover:scale-105 transition-all duration-300 flex items-center gap-2 group"
//       >
//         <Star className="group-hover:animate-pulse" size={15} />
//         Rate The Restaurant
//         <Star className="group-hover:animate-pulse" size={15} />
//       </button>

//       {/* Image Modal */}
//       {selectedImage && (
//         <div
//           className="fixed inset-0 bg-black/90 flex items-center justify-center z-50 p-4"
//           onClick={() => setSelectedImage(null)}
//         >
//           <div
//             className="relative max-w-6xl max-h-[90vh]"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <button
//               className="absolute -top-4 -right-4 bg-white text-gray-800 rounded-full p-2 shadow-2xl hover:scale-110 transition-transform z-10"
//               onClick={() => setSelectedImage(null)}
//             >
//               <ChevronLeft size={24} />
//             </button>
//             <img
//               src={selectedImage}
//               alt="Enlarged view"
//               className="max-w-full max-h-[90vh] object-contain rounded-2xl shadow-2xl"
//             />
//           </div>
//         </div>
//       )}

//       {/* Custom Scrollbar Styles */}
//       <style jsx>{`
//         .custom-scrollbar::-webkit-scrollbar {
//           width: 6px;
//         }
//         .custom-scrollbar::-webkit-scrollbar-track {
//           background: #f1f1f1;
//           border-radius: 10px;
//         }
//         .custom-scrollbar::-webkit-scrollbar-thumb {
//           background: #c1c1c1;
//           border-radius: 10px;
//         }
//         .custom-scrollbar::-webkit-scrollbar-thumb:hover {
//           background: #a8a8a8;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default Restaurant;

// import { useEffect, useState } from "react";
// import { useNavigate } from "react-router-dom";
// import api from "../api/axiosInstance";
// import {
//   ChevronLeft,
//   ChevronRight,
//   Clock,
//   Phone,
//   Star,
//   Menu,
//   ArrowRight,
// } from "lucide-react";

// const Restaurant = () => {
//   const navigate = useNavigate();
//   const [categories, setCategories] = useState([]);
//   const [loading, setLoading] = useState(true);
//   const [currentSlide, setCurrentSlide] = useState(0);
//   const [selectedImage, setSelectedImage] = useState(null);

//   const carouselImages = [
//     {
//       id: 1,
//       image:
//         "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758112819/WhatsApp_Image_2025-09-17_at_5.57.59_PM-min_trljoi.jpg",
//     },
//     {
//       id: 2,
//       image:
//         "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758112819/WhatsApp_Image_2025-09-17_at_5.57.46_PM-min_sjhcpy.jpg",
//     },
//     {
//       id: 3,
//       image:
//         "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758112819/WhatsApp_Image_2025-09-17_at_5.58.00_PM-min_geltlb.jpg",
//     },
//   ];

//   // 🔹 Fetch categories from backend
//   useEffect(() => {
//     const fetchCategories = async () => {
//       try {
//         const res = await api.get("/restaurant/categories/get/all");
//         setCategories(res.data);
//       } catch (err) {
//         console.error("Failed to load categories:", err);
//       } finally {
//         setLoading(false);
//       }
//     };
//     fetchCategories();
//   }, []);

//   // 🔹 Carousel autoplay
//   useEffect(() => {
//     const interval = setInterval(() => {
//       setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
//     }, 5000);
//     return () => clearInterval(interval);
//   }, [carouselImages.length]);

//   const nextSlide = () => {
//     setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
//   };

//   const prevSlide = () => {
//     setCurrentSlide((prev) =>
//       prev === 0 ? carouselImages.length - 1 : prev - 1
//     );
//   };

//   if (loading) {
//     return (
//       <div className="min-h-screen bg-gradient-to-br from-green-50 to-lime-50 flex items-center justify-center">
//         <div className="text-center">
//           <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-green-600 mx-auto mb-4"></div>
//           <p className="text-gray-600 text-lg">Loading menu...</p>
//         </div>
//       </div>
//     );
//   }

//   return (
//     <div className="min-h-screen bg-gradient-to-br from-green-50 to-lime-50 py-8 px-4 sm:px-6 lg:px-8 relative">
//       <div className="max-w-7xl mx-auto">
//         {/* Header */}
//         <div className="text-center mb-12">
//           <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-4 tracking-tight">
//             Golf View Cafe
//           </h1>
//           <p className="text-xl md:text-2xl text-gray-600 max-w-2xl mx-auto">
//             Experience exquisite dining with panoramic golf course views
//           </p>
//         </div>

//         <div className="grid grid-cols-1 xl:grid-cols-3 gap-8 lg:gap-12">
//           {/* Categories List - Left Sidebar */}
//           {/* <div className="xl:col-span-1">
//             <div className="bg-white rounded-3xl shadow-2xl p-6 lg:p-8 sticky top-8">
//               <div className="text-center mb-8">
//                 <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-2">
//                   Our Menu
//                 </h2>
//                 <div className="w-24 h-1 bg-gradient-to-r from-green-500 to-lime-500 mx-auto rounded-full"></div>
//               </div>

//               <div className="space-y-4 max-h-[calc(100vh-200px)] overflow-y-auto pr-2 custom-scrollbar">
//                 {categories.map((cat) => (
//                   <div
//                     key={cat.id}
//                     className="group bg-gradient-to-r from-white to-green-50 rounded-2xl cursor-pointer hover:shadow-2xl transition-all duration-300 hover:scale-[1.02] border border-green-100 overflow-hidden"
//                     onClick={() => navigate(`/category/${cat.id}`)}
//                   >
//                     <div className="flex items-center p-4 lg:p-6">
//                       <div className="relative">
//                         <img
//                           src={cat.imageUrl}
//                           alt={cat.title}
//                           className="w-20 h-20 lg:w-24 lg:h-24 object-cover rounded-xl shadow-md group-hover:scale-110 transition-transform duration-300"
//                         />
//                         <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-xl"></div>
//                       </div>
//                       <div className="ml-4 lg:ml-6 flex-1">
//                         <h3 className="text-xl lg:text-2xl font-bold text-gray-900 group-hover:text-green-700 transition-colors">
//                           {cat.title}
//                         </h3>
//                         <div className="w-12 h-1 bg-green-500 mt-2 rounded-full group-hover:w-16 transition-all duration-300"></div>
//                       </div>
//                       <div className="text-green-500 opacity-0 group-hover:opacity-100 transform translate-x-2 group-hover:translate-x-0 transition-all duration-300">
//                         <ChevronRight size={24} />
//                       </div>
//                     </div>
//                   </div>
//                 ))}
//               </div>
//             </div>
//           </div> */}

//           {/* Temporary Menu Explorer Section */}
//           <div className="xl:col-span-1">
//             <div className="bg-white rounded-3xl shadow-2xl p-6 lg:p-8 sticky top-8">
//               <div className="text-center mb-8">
//                 <div className="w-20 h-20 bg-gradient-to-br from-green-500 to-lime-500 rounded-2xl flex items-center justify-center mx-auto mb-4">
//                   <Menu size={40} className="text-white" />
//                 </div>
//                 <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-2">
//                   Explore Our Menus
//                 </h2>
//                 <div className="w-24 h-1 bg-gradient-to-r from-green-500 to-lime-500 mx-auto rounded-full"></div>
//                 <p className="text-gray-600 mt-4 text-lg">
//                   Browse our complete menu collection
//                 </p>
//               </div>

//               <div className="space-y-6">
//                 {/* Feature Cards */}
//                 {/* <div className="bg-gradient-to-br from-green-50 to-lime-50 rounded-2xl p-6 border border-green-200">
//                   <h3 className="text-xl font-bold text-gray-900 mb-3 text-center">
//                     📋 Complete Menu Collection
//                   </h3>
//                   <ul className="space-y-2 text-gray-700 text-center">
//                     <li>• Full restaurant menu</li>
//                     <li>• Beverage selection</li>
//                     <li>• Special offers</li>
//                     <li>• Seasonal items</li>
//                   </ul>
//                 </div> */}

//                 {/* CTA Button */}
//                 <button
//                   onClick={() => navigate("/menu-gallery")}
//                   className="group w-full bg-gradient-to-r from-green-500 to-lime-500 hover:from-green-600 hover:to-lime-600 text-white font-bold py-4 px-6 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 flex items-center justify-center gap-3"
//                 >
//                   <span className="text-lg">View All Menus</span>
//                   <ArrowRight
//                     className="group-hover:translate-x-1 transition-transform duration-300"
//                     size={20}
//                   />
//                 </button>

//                 {/* Quick Preview */}
//                 {/* <div className="text-center">
//                   <p className="text-gray-500 text-sm mb-3">
//                     Featuring 9 beautifully designed menu pages
//                   </p>
//                   <div className="grid grid-cols-3 gap-2 opacity-70">
//                     {[1, 2, 3, 4, 5, 6].map((num) => (
//                       <div
//                         key={num}
//                         className="aspect-square bg-gradient-to-br from-green-200 to-lime-200 rounded-lg flex items-center justify-center"
//                       >
//                         <span className="text-green-600 font-bold text-xs">
//                           Menu {num}
//                         </span>
//                       </div>
//                     ))}
//                   </div>
//                 </div> */}
//               </div>
//             </div>
//           </div>

//           {/* Main Content Area */}
//           <div className="xl:col-span-2 space-y-8 lg:space-y-12">
//             {/* Carousel Section */}
//             <div className="bg-white rounded-3xl shadow-2xl p-4 lg:p-6 relative overflow-hidden">
//               <div className="relative">
//                 <div
//                   className="flex transition-transform duration-700 ease-out"
//                   style={{ transform: `translateX(-${currentSlide * 100}%)` }}
//                 >
//                   {carouselImages.map((item) => (
//                     <div
//                       key={item.id}
//                       className="flex-shrink-0 w-full cursor-pointer"
//                       onClick={() => setSelectedImage(item.image)}
//                     >
//                       <img
//                         src={item.image}
//                         alt="Restaurant ambiance"
//                         className="w-full h-64 sm:h-80 lg:h-96 xl:h-[500px] object-cover rounded-2xl shadow-lg"
//                       />
//                     </div>
//                   ))}
//                 </div>

//                 {/* Navigation Arrows */}
//                 <button
//                   onClick={prevSlide}
//                   className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-gray-800 rounded-full p-3 shadow-2xl transition-all duration-200 hover:scale-110"
//                 >
//                   <ChevronLeft size={24} />
//                 </button>
//                 <button
//                   onClick={nextSlide}
//                   className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-gray-800 rounded-full p-3 shadow-2xl transition-all duration-200 hover:scale-110"
//                 >
//                   <ChevronRight size={24} />
//                 </button>

//                 {/* Dots Indicator */}
//                 <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-3">
//                   {carouselImages.map((_, idx) => (
//                     <button
//                       key={idx}
//                       onClick={() => setCurrentSlide(idx)}
//                       className={`w-3 h-3 rounded-full transition-all duration-300 ${
//                         idx === currentSlide
//                           ? "bg-white scale-125"
//                           : "bg-white/60 hover:bg-white/80"
//                       }`}
//                     ></button>
//                   ))}
//                 </div>
//               </div>
//             </div>

//             {/* Info Cards Grid */}
//             <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
//               {/* Opening Hours */}
//               <div className="bg-gradient-to-br from-green-500 to-lime-600 rounded-3xl p-6 lg:p-8 text-white shadow-2xl">
//                 <div className="flex items-center mb-6">
//                   <div className="bg-white/20 p-3 rounded-2xl mr-4">
//                     <Clock size={32} />
//                   </div>
//                   <h2 className="text-2xl lg:text-3xl font-bold">
//                     Opening Hours
//                   </h2>
//                 </div>

//                 <div className="space-y-4 text-lg">
//                   <div className="flex justify-between items-center py-3 border-b border-white/20">
//                     <span className="font-semibold">Saturday - Thursday</span>
//                     <div className="text-right">
//                       <div>8:00 AM - 12:00 AM</div>
//                       <div>3:00 PM - 10:00 PM</div>
//                     </div>
//                   </div>
//                   <div className="flex justify-between items-center py-3">
//                     <span className="font-semibold">Friday</span>
//                     <div className="text-right">
//                       <div>8:00 AM - 10:00 AM</div>
//                       <div>3:00 PM - 10:00 PM</div>
//                     </div>
//                   </div>
//                 </div>
//               </div>

//               {/* Pre-booking Info */}
//               <div className="bg-gradient-to-br from-indigo-500 to-purple-600 rounded-3xl p-6 lg:p-8 text-white shadow-2xl">
//                 <div className="flex items-center mb-6">
//                   <div className="bg-white/20 p-3 rounded-2xl mr-4">
//                     <Phone size={32} />
//                   </div>
//                   <h2 className="text-2xl lg:text-3xl font-bold">
//                     Pre-Booking
//                   </h2>
//                 </div>

//                 <div className="space-y-6">
//                   <p className="text-xl leading-relaxed">
//                     Reserve your table in advance for the perfect dining
//                     experience
//                   </p>

//                   <div className="bg-white/10 rounded-2xl p-4 text-center">
//                     <div className="text-2xl lg:text-3xl font-bold mb-2">
//                       +88 01769660123
//                     </div>
//                     <p className="text-white/80">Call now to book your table</p>
//                   </div>
//                 </div>
//               </div>
//             </div>

//             {/* Additional Info */}
//             <div className="bg-white rounded-3xl shadow-2xl p-6 lg:p-8">
//               <h3 className="text-2xl lg:text-3xl font-bold text-center mb-6 text-gray-900">
//                 Why Choose Golf View Cafe?
//               </h3>
//               <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
//                 <div className="space-y-3">
//                   <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mx-auto">
//                     <span className="text-2xl">🌿</span>
//                   </div>
//                   <h4 className="font-bold text-lg text-gray-900">
//                     Fresh Ingredients
//                   </h4>
//                   <p className="text-gray-600">
//                     Locally sourced, premium quality ingredients
//                   </p>
//                 </div>
//                 <div className="space-y-3">
//                   <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mx-auto">
//                     <span className="text-2xl">🏌️</span>
//                   </div>
//                   <h4 className="font-bold text-lg text-gray-900">
//                     Golf Course Views
//                   </h4>
//                   <p className="text-gray-600">
//                     Panoramic views of the beautiful golf course
//                   </p>
//                 </div>
//                 <div className="space-y-3">
//                   <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mx-auto">
//                     <span className="text-2xl">👨‍🍳</span>
//                   </div>
//                   <h4 className="font-bold text-lg text-gray-900">
//                     Expert Chefs
//                   </h4>
//                   <p className="text-gray-600">
//                     Skilled chefs creating culinary masterpieces
//                   </p>
//                 </div>
//               </div>
//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Floating Review Button */}
//       <button
//         onClick={() => navigate("/review")}
//         className="fixed top-20 right-1 z-40 lg:z-50 mt-[15px] px-6 py-2 lg:py-4 text-[14px] lg:text-[18px] rounded-2xl font-bold text-white bg-gradient-to-r from-lime-500 to-lime-500 shadow-2xl hover:shadow-3xl hover:scale-105 transition-all duration-300 flex items-center gap-2 group"
//       >
//         <Star className="group-hover:animate-pulse" size={15} />
//         Rate The Restaurant
//         <Star className="group-hover:animate-pulse" size={15} />
//       </button>

//       {/* Image Modal */}
//       {selectedImage && (
//         <div
//           className="fixed inset-0 bg-black/90 flex items-center justify-center z-50 p-4"
//           onClick={() => setSelectedImage(null)}
//         >
//           <div
//             className="relative max-w-6xl max-h-[90vh]"
//             onClick={(e) => e.stopPropagation()}
//           >
//             <button
//               className="absolute -top-4 -right-4 bg-white text-gray-800 rounded-full p-2 shadow-2xl hover:scale-110 transition-transform z-10"
//               onClick={() => setSelectedImage(null)}
//             >
//               <ChevronLeft size={24} />
//             </button>
//             <img
//               src={selectedImage}
//               alt="Enlarged view"
//               className="max-w-full max-h-[90vh] object-contain rounded-2xl shadow-2xl"
//             />
//           </div>
//         </div>
//       )}

//       {/* Custom Scrollbar Styles */}
//       <style jsx>{`
//         .custom-scrollbar::-webkit-scrollbar {
//           width: 6px;
//         }
//         .custom-scrollbar::-webkit-scrollbar-track {
//           background: #f1f1f1;
//           border-radius: 10px;
//         }
//         .custom-scrollbar::-webkit-scrollbar-thumb {
//           background: #c1c1c1;
//           border-radius: 10px;
//         }
//         .custom-scrollbar::-webkit-scrollbar-thumb:hover {
//           background: #a8a8a8;
//         }
//       `}</style>
//     </div>
//   );
// };

// export default Restaurant;
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "../api/axiosInstance";
import {
  ChevronLeft,
  ChevronRight,
  Clock,
  Phone,
  Star,
  ArrowRight,
} from "lucide-react";

const Restaurant = () => {
  const navigate = useNavigate();
  const [categories, setCategories] = useState([]);
  const [loading, setLoading] = useState(true);
  const [currentSlide, setCurrentSlide] = useState(0);
  const [selectedImage, setSelectedImage] = useState(null);

  const carouselImages = [
    {
      id: 1,
      image:
        "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758112819/WhatsApp_Image_2025-09-17_at_5.57.59_PM-min_trljoi.jpg",
    },
    {
      id: 2,
      image:
        "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758112819/WhatsApp_Image_2025-09-17_at_5.57.46_PM-min_sjhcpy.jpg",
    },
    {
      id: 3,
      image:
        "https://res.cloudinary.com/dxdvcplbl/image/upload/v1758112819/WhatsApp_Image_2025-09-17_at_5.58.00_PM-min_geltlb.jpg",
    },
  ];

  // Social media links
  const socialLinks = {
    facebook: "https://www.facebook.com/share/1662ufVo5d/",
    google:
      "https://www.google.com/search?client=ms-android-samsung-ss&sca_esv=792560e52f66799b&sxsrf=AE3TifNv58Ko7EeX8f394r4noIFaQaAFUw:1758516474210&q=golf+view+resturant+rajendrapur+reviews&uds=AOm0WdGzFl_-Sc0JzSQUtxIBG54-XHrujKkELGtZrSO9oRqEzibxezfF8p4iOUCEoBo7lidWL-fwmLeAJUofOxy-l4inlAoAgSWI_W8ytsdlrZddxrx7TZhuM-ByTCGOOQvk1nOxMA4M_Pk10mluSNYhIBzw5Nivh6B4ZHxyY0zVUjGCY2wjQDxblPPXWP6bWfF5nrqeVkPv6F1OdaB3EY0er5oatpmY9g3xAWx_9nwOA4aGpLAOwIPIycwFzOS_k65xwtdIa8gAY6GElVRMhwt8hSLD0K4_SqWsL6UnYVoVnfT6Vv21atIHU3zOAv2q-k2GHUEajonZ9RzQ8Zb4mIWUn6qqKAThWaCyjwdR9-aLbE40MoQs1yA&si=AMgyJEtREmoPL4P1I5IDCfuA8gybfVI2d5Uj7QMwYCZHKDZ-E5mQcxaHtBrcNvx_OLntQwhOtCTztzaXCLvEQgSI42QHMCoVTQZ7pOOnnxYuMnntQNHDJk2zzknvDvt2OzpNKM6OK0Sl_ZBj-BHA6m0rfCHcSK5zHA%3D%3D&sa=X&ved=2ahUKEwi2spuuyOuPAxV1yzgGHbXCEC8Qk8gLegQIGhAB&ictx=1&biw=384&bih=695&dpr=2.81",
    instagram:
      "https://www.instagram.com/golf.viewrestaurant?igsh=MWgweWFoc2RneGJyNQ==",
  };

  // 🔹 Fetch categories from backend
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const res = await api.get("/restaurant/categories/get/all");
        setCategories(res.data);
      } catch (err) {
        console.error("Failed to load categories:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchCategories();
  }, []);

  // 🔹 Carousel autoplay
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
    }, 5000);
    return () => clearInterval(interval);
  }, [carouselImages.length]);

  const nextSlide = () => {
    setCurrentSlide((prev) => (prev + 1) % carouselImages.length);
  };

  const prevSlide = () => {
    setCurrentSlide((prev) =>
      prev === 0 ? carouselImages.length - 1 : prev - 1
    );
  };

  const handleSocialClick = (platform) => {
    window.open(socialLinks[platform], "_blank", "noopener,noreferrer");
  };

  if (loading) {
    return (
      <div className="min-h-screen bg-gradient-to-br from-green-50 to-lime-50 flex items-center justify-center">
        <div className="text-center">
          <div className="animate-spin rounded-full h-16 w-16 border-b-2 border-green-600 mx-auto mb-4"></div>
          <p className="text-gray-600 text-lg">Loading menu...</p>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gradient-to-br from-green-50 to-lime-50 py-8 px-4 sm:px-6 lg:px-8 relative">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className="text-4xl md:text-6xl font-bold text-gray-900 mb-4 tracking-tight">
            Golf View Cafe
          </h1>
          <p className="text-xl md:text-2xl text-gray-600 max-w-2xl mx-auto">
            Experience exquisite dining with panoramic golf course views
          </p>
        </div>

        <div className="grid grid-cols-1 xl:grid-cols-3 gap-8 lg:gap-12">
          {/* Categories List - Left Sidebar */}
          {/* <div className="xl:col-span-1">
            <div className="bg-white rounded-3xl shadow-2xl p-6 lg:p-8 sticky top-8">
              <div className="text-center mb-8">
                <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-2">
                  Our Menu
                </h2>
                <div className="w-24 h-1 bg-gradient-to-r from-green-500 to-lime-500 mx-auto rounded-full"></div>
              </div>

              <div className="space-y-4 max-h-[calc(100vh-200px)] overflow-y-auto pr-2 custom-scrollbar">
                {categories.map((cat) => (
                  <div
                    key={cat.id}
                    className="group bg-gradient-to-r from-white to-green-50 rounded-2xl cursor-pointer hover:shadow-2xl transition-all duration-300 hover:scale-[1.02] border border-green-100 overflow-hidden"
                    onClick={() => navigate(`/category/${cat.id}`)}
                  >
                    <div className="flex items-center p-4 lg:p-6">
                      <div className="relative">
                        <img
                          src={cat.imageUrl}
                          alt={cat.title}
                          className="w-20 h-20 lg:w-24 lg:h-24 object-cover rounded-xl shadow-md group-hover:scale-110 transition-transform duration-300"
                        />
                        <div className="absolute inset-0 bg-gradient-to-t from-black/20 to-transparent rounded-xl"></div>
                      </div>
                      <div className="ml-4 lg:ml-6 flex-1">
                        <h3 className="text-xl lg:text-2xl font-bold text-gray-900 group-hover:text-green-700 transition-colors">
                          {cat.title}
                        </h3>
                        <div className="w-12 h-1 bg-green-500 mt-2 rounded-full group-hover:w-16 transition-all duration-300"></div>
                      </div>
                      <div className="text-green-500 opacity-0 group-hover:opacity-100 transform translate-x-2 group-hover:translate-x-0 transition-all duration-300">
                        <ChevronRight size={24} />
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div> */}

          {/* Temporary Menu Explorer Section */}
          <div className="xl:col-span-1">
            <div className="bg-white rounded-3xl shadow-2xl p-6 lg:p-8 sticky top-8">
              <div className="text-center mb-8">
                {/* Social Media Icons Section */}
                <div className="mb-8">
                  <h3 className="text-xl font-bold text-gray-900 mb-4">
                    Review us at
                  </h3>
                  <div className="flex justify-center gap-4">
                    {/* Facebook */}
                    <button
                      onClick={() => handleSocialClick("facebook")}
                      className="group p-3 bg-blue-600 hover:bg-blue-700 rounded-2xl transition-all duration-300 transform hover:scale-110 hover:shadow-lg"
                    >
                      <svg
                        className="w-6 h-6 text-white"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z" />
                      </svg>
                    </button>

                    {/* Google */}
                    <button
                      onClick={() => handleSocialClick("google")}
                      className="group p-3 bg-red-600 hover:bg-red-700 rounded-2xl transition-all duration-300 transform hover:scale-110 hover:shadow-lg"
                    >
                      <svg
                        className="w-6 h-6 text-white"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-1 17.93c-3.95-.49-7-3.85-7-7.93 0-.62.08-1.21.21-1.79L9 15v1c0 1.1.9 2 2 2v1.93zm6.9-2.54c-.26-.81-1-1.39-1.9-1.39h-1v-3c0-.55-.45-1-1-1H8v-2h2c.55 0 1-.45 1-1V7h2c1.1 0 2-.9 2-2v-.41c2.93 1.19 5 4.06 5 7.41 0 2.08-.8 3.97-2.1 5.39z" />
                      </svg>
                    </button>

                    {/* Instagram */}
                    <button
                      onClick={() => handleSocialClick("instagram")}
                      className="group p-3 bg-gradient-to-r from-purple-500 to-pink-500 hover:from-purple-600 hover:to-pink-600 rounded-2xl transition-all duration-300 transform hover:scale-110 hover:shadow-lg"
                    >
                      <svg
                        className="w-6 h-6 text-white"
                        fill="currentColor"
                        viewBox="0 0 24 24"
                      >
                        <path d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z" />
                      </svg>
                    </button>
                  </div>
                </div>

                <h2 className="text-3xl lg:text-4xl font-bold text-gray-900 mb-2">
                  Explore Our Menu
                </h2>
                <div className="w-24 h-1 bg-gradient-to-r from-green-500 to-lime-500 mx-auto rounded-full"></div>
                <p className="text-gray-600 mt-4 text-lg">
                  Browse our complete menu collection
                </p>
              </div>

              <div className="space-y-6">
                {/* CTA Button */}
                <button
                  onClick={() => navigate("/menu-gallery")}
                  className="group w-full bg-gradient-to-r from-green-500 to-lime-500 hover:from-green-600 hover:to-lime-600 text-white font-bold py-4 px-6 rounded-2xl shadow-lg hover:shadow-xl transition-all duration-300 transform hover:scale-105 flex items-center justify-center gap-3"
                >
                  <span className="text-lg">Check Our Menu</span>
                  <ArrowRight
                    className="group-hover:translate-x-1 transition-transform duration-300"
                    size={20}
                  />
                </button>
              </div>
            </div>
          </div>

          {/* Main Content Area */}
          <div className="xl:col-span-2 space-y-8 lg:space-y-12">
            {/* Carousel Section */}
            <div className="bg-white rounded-3xl shadow-2xl p-4 lg:p-6 relative overflow-hidden">
              <div className="relative">
                <div
                  className="flex transition-transform duration-700 ease-out"
                  style={{ transform: `translateX(-${currentSlide * 100}%)` }}
                >
                  {carouselImages.map((item) => (
                    <div
                      key={item.id}
                      className="flex-shrink-0 w-full cursor-pointer"
                      onClick={() => setSelectedImage(item.image)}
                    >
                      <img
                        src={item.image}
                        alt="Restaurant ambiance"
                        className="w-full h-64 sm:h-80 lg:h-96 xl:h-[500px] object-cover rounded-2xl shadow-lg"
                      />
                    </div>
                  ))}
                </div>

                {/* Navigation Arrows */}
                <button
                  onClick={prevSlide}
                  className="absolute left-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-gray-800 rounded-full p-3 shadow-2xl transition-all duration-200 hover:scale-110"
                >
                  <ChevronLeft size={24} />
                </button>
                <button
                  onClick={nextSlide}
                  className="absolute right-4 top-1/2 -translate-y-1/2 bg-white/90 hover:bg-white text-gray-800 rounded-full p-3 shadow-2xl transition-all duration-200 hover:scale-110"
                >
                  <ChevronRight size={24} />
                </button>

                {/* Dots Indicator */}
                <div className="absolute bottom-4 left-1/2 transform -translate-x-1/2 flex gap-3">
                  {carouselImages.map((_, idx) => (
                    <button
                      key={idx}
                      onClick={() => setCurrentSlide(idx)}
                      className={`w-3 h-3 rounded-full transition-all duration-300 ${
                        idx === currentSlide
                          ? "bg-white scale-125"
                          : "bg-white/60 hover:bg-white/80"
                      }`}
                    ></button>
                  ))}
                </div>
              </div>
            </div>

            {/* Info Cards Grid */}
            <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 lg:gap-8">
              {/* Opening Hours */}
              <div className="bg-gradient-to-br from-green-500 to-lime-600 rounded-3xl p-6 lg:p-8 text-white shadow-2xl">
                <div className="flex items-center mb-6">
                  <div className="bg-white/20 p-3 rounded-2xl mr-4">
                    <Clock size={32} />
                  </div>
                  <h2 className="text-2xl lg:text-3xl font-bold">
                    Opening Hours
                  </h2>
                </div>

                <div className="space-y-4 text-lg">
                  <div className="flex justify-between items-center py-3 border-b border-white/20">
                    <span className="font-semibold">Saturday - Thursday</span>
                    <div className="text-right">
                      <div>8:00 AM - 12:00 AM</div>
                      <div>3:00 PM - 10:00 PM</div>
                    </div>
                  </div>
                  <div className="flex justify-between items-center py-3">
                    <span className="font-semibold">Friday</span>
                    <div className="text-right">
                      <div>8:00 AM - 10:00 AM</div>
                      <div>3:00 PM - 10:00 PM</div>
                    </div>
                  </div>
                </div>
              </div>

              {/* Pre-booking Info */}
              <div className="bg-gradient-to-br from-indigo-500 to-purple-600 rounded-3xl p-6 lg:p-8 text-white shadow-2xl">
                <div className="flex items-center mb-6">
                  <div className="bg-white/20 p-3 rounded-2xl mr-4">
                    <Phone size={32} />
                  </div>
                  <h2 className="text-2xl lg:text-3xl font-bold">
                    Pre-Booking
                  </h2>
                </div>

                <div className="space-y-6">
                  <p className="text-xl leading-relaxed">
                    Reserve your table in advance for the perfect dining
                    experience
                  </p>

                  <div className="bg-white/10 rounded-2xl p-4 text-center">
                    <div className="text-2xl lg:text-3xl font-bold mb-2">
                      +88 01769660123
                    </div>
                    <p className="text-white/80">Call now to book your table</p>
                  </div>
                </div>
              </div>
            </div>

            {/* Additional Info */}
            <div className="bg-white rounded-3xl shadow-2xl p-6 lg:p-8">
              <h3 className="text-2xl lg:text-3xl font-bold text-center mb-6 text-gray-900">
                Why Choose Golf View Cafe?
              </h3>
              <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-center">
                <div className="space-y-3">
                  <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mx-auto">
                    <span className="text-2xl">🌿</span>
                  </div>
                  <h4 className="font-bold text-lg text-gray-900">
                    Fresh Ingredients
                  </h4>
                  <p className="text-gray-600">
                    Locally sourced, premium quality ingredients
                  </p>
                </div>
                <div className="space-y-3">
                  <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mx-auto">
                    <span className="text-2xl">🏌️</span>
                  </div>
                  <h4 className="font-bold text-lg text-gray-900">
                    Golf Course Views
                  </h4>
                  <p className="text-gray-600">
                    Panoramic views of the beautiful golf course
                  </p>
                </div>
                <div className="space-y-3">
                  <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mx-auto">
                    <span className="text-2xl">👨‍🍳</span>
                  </div>
                  <h4 className="font-bold text-lg text-gray-900">
                    Expert Chefs
                  </h4>
                  <p className="text-gray-600">
                    Skilled chefs creating culinary masterpieces
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Floating Review Button */}
      <button
        onClick={() => navigate("/review")}
        className="fixed top-20 right-1 z-40 lg:z-50 mt-[15px] px-6 py-2 lg:py-4 text-[14px] lg:text-[18px] rounded-2xl font-bold text-white bg-gradient-to-r from-lime-500 to-lime-500 shadow-2xl hover:shadow-3xl hover:scale-105 transition-all duration-300 flex items-center gap-2 group"
      >
        <Star className="group-hover:animate-pulse" size={15} />
        Rate The Restaurant
        <Star className="group-hover:animate-pulse" size={15} />
      </button>

      {/* Image Modal */}
      {selectedImage && (
        <div
          className="fixed inset-0 bg-black/90 flex items-center justify-center z-50 p-4"
          onClick={() => setSelectedImage(null)}
        >
          <div
            className="relative max-w-6xl max-h-[90vh]"
            onClick={(e) => e.stopPropagation()}
          >
            <button
              className="absolute -top-4 -right-4 bg-white text-gray-800 rounded-full p-2 shadow-2xl hover:scale-110 transition-transform z-10"
              onClick={() => setSelectedImage(null)}
            >
              <ChevronLeft size={24} />
            </button>
            <img
              src={selectedImage}
              alt="Enlarged view"
              className="max-w-full max-h-[90vh] object-contain rounded-2xl shadow-2xl"
            />
          </div>
        </div>
      )}

      {/* Custom Scrollbar Styles */}
      <style jsx>{`
        .custom-scrollbar::-webkit-scrollbar {
          width: 6px;
        }
        .custom-scrollbar::-webkit-scrollbar-track {
          background: #f1f1f1;
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb {
          background: #c1c1c1;
          border-radius: 10px;
        }
        .custom-scrollbar::-webkit-scrollbar-thumb:hover {
          background: #a8a8a8;
        }
      `}</style>
    </div>
  );
};

export default Restaurant;
